<template>
  <div class="container-fluid section-div" v-if="visible">
    <div class="section-title-div section-title-div-1">
      <div class="section-title-line-div">
        <span class="section-title-line"></span>
      </div>
      <span class="section-title-1">{{ $t('build_your_jewel.title') }} </span>
      <div class="section-title-line-div">
        <span class="section-title-line"></span>
      </div>
    </div>
    <b-alert variant="warning" show v-if="showMessage && !expired">{{ $t('build_your_jewel.free_trial', [expiryDate]) }}
    </b-alert>
    <div class="relative-div">
      <div class="overlay" v-if="showMessage && expired">
        <div class="overlay-content">
          <b-alert variant="warning" show>{{ $t('build_your_jewel.free_trial_expired', [expiryDate]) }}</b-alert>
        </div>
      </div>

      <div class="row m-0 d-flex justify-content-center pb-3">
        <div class="col-6 col-md-4 col-lg-3" v-for="option in stonesNumberOptions">
          <div class="stone-number-option" @click="selectStonesNumber(option)"
            :class="{ 'selected-stone-number-option': selectedStonesNumber == option.value }">
            <div class="option-icons">
              <svg class="option-icon" v-for="index in option.value" :key="index" width="100%" height="100%"
                viewBox="0 0 79 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39 2L2 49.5L39 96.5L77.5 49.5L39 2Z" />
              </svg>
            </div>
            <div class="option-text">{{ option.text }}</div>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3">
          <div class="stone-number-option" @click="goToPreconfigured()">
            <div class="preconfigured-option">
              <svg class="preconfigured-icon" viewBox="0 0 260 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M36 2H224L256 36L224 70H36L4 36L36 2Z" />
              </svg>
              <span class="preconfigured-text">{{ $t('build_your_jewel.preconfigured') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--Button Modifica per tenere solo il flusso a partire dalla montatura
      <div class="d-flex justify-content-center pb-3" v-if="selectedStonesNumber">
        <div class="col-6 col-md-4 d-flex" @click="goToBuildYourJewel('STONE')">
          <div class="starts-with-btn" :class="{ 'active': selectedStartsWith == 'STONE' }">{{
    $t('build_your_jewel.starts_with_stone') }}</div>
        </div>
        <div class="col-6 col-md-4 offset-md-1 d-flex" @click="goToBuildYourJewel('SETTING')">
          <div class="starts-with-btn" :class="{ 'active': selectedStartsWith == 'SETTING' }">{{
    $t('build_your_jewel.starts_with_setting') }}</div>
        </div>
      </div>-->

      <div v-if="chatbotEnabled" class="d-flex justify-content-center pb-4">
        <button class="byj-ai-btn" @click="openAIChatbot">
          🤖 Configura con AI
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import buildYourJewel from "../api/build-your-jewel";
import { mapState } from 'vuex';
import Vue from "vue";

// Sezione (websiteSectionFilter) dei gioielli gia' configurati con pietre D-VS
const PRECONFIGURED_SECTION = "PRECONFIGURED_D_VS";

export default {
  data() {
    return {
      stonesNumber: [],
      selectedStonesNumber: null,
      selectedStartsWith: null,
      expiryDate: null,
      expired: false,
      showMessage: false,
      chatbotExpiryDate: null
    }
  },
  mounted() {
    buildYourJewel.getStoneFilters().then((response) => {
      this.stonesNumber = response.data.stonesNumber;

      if (response.data.chatbotExpiryDate) {
        this.chatbotExpiryDate = new Date(response.data.chatbotExpiryDate);
      }

      if (response.data.buildYourJewelExpiryDate) {
        const expiryDate = new Date(response.data.buildYourJewelExpiryDate);
        this.expiryDate = Vue.formatShipmentDate(expiryDate);
        const daysDifference = Math.ceil((expiryDate - Date.now()) / (1000 * 3600 * 24));
        if (daysDifference < 30) {
          this.showMessage = true;
          if (daysDifference <= 0)
            this.expired = true;
        };
      }

    });
  },
  computed: {
    stonesNumberOptions() {
      return this.stonesNumber.map(sn => {
        return { 'text': this.$t("build_your_jewel.with") + " " + sn + " " + (sn > 1 ? this.$t("build_your_jewel.stones") : this.$t("build_your_jewel.stone")), 'value': sn }
      });
    },
    ...mapState({
      credential: (state) => state.config.credential,
    }),
    visible: function () {
      return this.stonesNumber.length > 0 && (this.expiryDate || this.credential.isBO);
    },
    chatbotEnabled: function () {
      //if (this.credential.isBO) return true;
      return this.chatbotExpiryDate != null && this.chatbotExpiryDate > new Date();
    },
    isMediumUp() {
      return window.matchMedia('(min-width: 768px)').matches; // 'md' breakpoint
    }
  },
  methods: {
    selectStonesNumber(option) {
      this.selectedStonesNumber = option.value
      // Modifica per tenere solo il flusso a partire dalla montatura
      this.$router.push({ name: 'build-your-jewel', params: { startFrom: 'SETTING', productType: 'BUILD_YOUR_JEWEL', stonesNumber: this.selectedStonesNumber } })
    },
    goToPreconfigured() {
      this.$router.push({
        name: 'list.sublist',
        params: { productType: 'JEWELLERY' },
        query: { section: PRECONFIGURED_SECTION }
      })
    },
    goToBuildYourJewel(option) {
      this.selectedStartsWith = option
      if (this.selectedStartsWith) {
        this.$router.push({ name: 'build-your-jewel', params: { startFrom: this.selectedStartsWith, productType: 'BUILD_YOUR_JEWEL', stonesNumber: this.selectedStonesNumber } })
      }
    },
    openAIChatbot() {
      this.$root.$emit('open-chatbot');
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.col-md-3.d-flex {
  justify-content: center;

  img {
    border-radius: 5%;
  }

  span {
    position: absolute;
    display: block;
    width: 85%;
    bottom: 15px;
    font-weight: bold;
    text-transform: uppercase;
  }
}

.section-div {
  background: linear-gradient(0deg, #44607E 0%, #254669 47%, #00274F 100%);
  position: relative;
  padding-top: 30px;
}

.section-div-separator {
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    border-top: 30px solid #44607E;
    border-right: 2500px solid transparent;
  }
}


.section-title-1 {
  color: var(--secondary-color-1);
  text-transform: uppercase;
  font-size: 30px;
  font-family: var(--secondary-font-family);
  margin-bottom: 15px;
  display: table-cell;
  white-space: nowrap;
}

.section-title-line {
  background: var(--secondary-color-1);
  height: 1px;
  width: 100%;
  content: '';
  display: block;
}

.section-title-line-div {
  width: 50%;
  display: table-cell;
  vertical-align: middle;
  padding: 0px 15px;
}

.section-title-div {
  margin-bottom: 20px;
}

.section-title-div-1 {
  padding-top: 20px;
}

.relative-div {
  position: relative;
  margin-right: -15px;
  margin-left: -15px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 39, 79, 0.5);
  /* Adjust the opacity as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.overlay-content {
  color: white;
  /* Adjust text color */
  font-size: 20px;
  /* Adjust font size */
  text-align: center;
  padding: 15px;
}

@media only screen and (max-width: 768px) {
  * {
    font-size: 12px;
  }

  .btn.btn-byj {
    font-size: 14px;
  }

  .section-title-1 {
    font-size: 20px;
  }

  .option-icons {
    max-height: 50px;
  }
}

.stone-number-option {
  aspect-ratio: 1/1;
  margin: 10px;
  background-color: #00274E;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.option-text {
  position: absolute;
  z-index: 2;
  bottom: 15px;
  ;
}

.option-icons {
  display: flex;
  gap: 5px;
  max-height: 80px;
  padding: 0px 5px;
}

.selected-stone-number-option {
  background-color: white;
  color: #00274E;

  .option-icon {
    path {
      fill: white;
      stroke: #00274E;
    }
  }
}

.preconfigured-option {
  position: relative;
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preconfigured-icon {
  width: 100%;
  height: auto;

  path {
    fill: none;
    stroke: white;
    stroke-width: 2;
  }
}

.preconfigured-text {
  position: absolute;
  left: 15%;
  right: 15%;
  text-align: center;
  line-height: 1.2;
}

.option-icon {
  fill: #00274E;

  path {
    fill: 00274E;
    stroke: white;
    /* Define the stroke color */
    stroke-width: 2;
    /* Define the stroke width */
  }
}

.byj-ai-btn {
  background: transparent;
  color: var(--secondary-color-1);
  border: 2px solid var(--secondary-color-1);
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.03em;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: var(--secondary-color-1);
    color: var(--primary-color-1);
  }
}

.starts-with-btn {
  background-color: #00274E;
  margin: 10px;
  width: 100%;
  padding: 15px 0px;
  color: white;
  cursor: pointer;

  &.active {
    background-color: white;
    color: #00274E;
  }
}

::v-deep {
  .btn.btn-gi {
    background-color: transparent;
    /* Change the background color */
    color: var(--secondary-color-1);
    /* Change the text color */
    border-color: var(--secondary-color-1);
    /* Change the border color */
  }

  .btn.btn-byj {
    background-color: #e6e6e6;
    /* Change the background color */
    color: var(--primary-color-1);
    /* Change the text color */
    border-color: var(--primary-color-1);
    /* Change the border color */
    text-transform: uppercase;
  }

  .btn.btn-gi.active {
    background-color: var(--secondary-color-1);
    /* Change the active background color */
    color: var(--primary-color-1);
    /* Change the active text color */
    border-color: var(--secondary-color-1);
    /* Change the active border color */
  }
}
</style>